// extracted by css-extract-rspack-plugin
export default {"pageShell":"IwO9sd0SfsXCNZOB","grid":"T6N3LPDetIs7hVFW","tile":"mQcGunDlKFQrIM_G","tileIcon":"JcFzIMjjpNwVT4Hj","tileDescription":"iAzYYbWyM5elfBAZ"};